import React from 'react';

import Button from '../../Button/Button';
import Box from '../../Box/Box';
import HStack from '../../HStack/HStack';

import { ActionTypes, PrimaryActionTypes } from '../FullPageCelebration';

interface ActionsBoxProps {
  primaryAction?: PrimaryActionTypes;
  secondaryAction?: ActionTypes;
}

const ActionsBox = (props: ActionsBoxProps) => {
  const { primaryAction, secondaryAction } = props;

  const getButtonType = () => {
    if (secondaryAction?.label) {
      return 'primary';
    }

    if (primaryAction?.type) {
      return primaryAction.type;
    }

    return 'primary';
  };

  return (
    <Box top="large">
      <HStack>
        {!!secondaryAction?.label && (
          <Button id={secondaryAction?.id} onClick={secondaryAction?.callback}>
            {secondaryAction?.label}
          </Button>
        )}
        {!!primaryAction?.label && (
          <Button id={primaryAction?.id} onClick={primaryAction?.callback} type={getButtonType()}>
            {primaryAction?.label}
          </Button>
        )}
      </HStack>
    </Box>
  );
};

export default ActionsBox;
